<template>
  <div class="modal">
    <!-- <p id="updatetext" class="h4">更新中...</p> -->
    <spinner class="spinner" :line-size="6" :size="100" :speed="0.8" line-fg-color="#B23E53" text-fg-color="#FFF" :font-size="20" :spacing="5" :message="this.msg"></spinner>
  </div>
</template>

<script>
import Spinner from 'vue-simple-spinner'
export default {
  components: {
    Spinner
  },
  props: ['msg']
}
</script>

<style scoped>
.modal {
  display: block;
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}
.spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -50px;
  margin-left: -50px;
}
#updatetext {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: 60px;
  margin-left: -35px;
  z-index: 10;
  color: aliceblue
}
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue